import React from 'react';
import { Routes } from 'routing';
import { emptyInventoryFields, InventoryItem } from 'common/modules/inventory';
import { useSelector } from 'react-redux';
import * as InventorySelectors from 'selectors/InventorySelectors';
import { Redirect, useParams } from 'react-router-dom';
import { LoadingData } from 'services/types';
import NotFound from 'views/404';
import Spinner from 'common/components/Spinner';
import BaseItemView from './BaseItemView';
import { useTranslation } from 'services/localization';

const SingleItemWrapper = () => {
	const { t } = useTranslation();
	const { itemId } = useParams<{ itemId: string }>();
	const inventoryItems = useSelector(InventorySelectors.inventoryItems);
	const skuItems = useSelector(InventorySelectors.skuItems);
	const inventoryConfiguration = useSelector(InventorySelectors.inventoryConfiguration);

	const getSingleInventoryItem = (
		inventoryItems: LoadingData<InventoryItem[]>,
	): LoadingData<InventoryItem> => {
		if (inventoryItems.loading) {
			return { loading: true, data: null, error: null };
		}
		const selectedInventoryItem = inventoryItems.data?.find((item) => item.id === itemId);
		if (selectedInventoryItem) {
			return { loading: false, data: selectedInventoryItem, error: null };
		}
		return { loading: false, data: null, error: t('inventory.article.notFound', 'No item found') };
	};

	const item = getSingleInventoryItem(inventoryItems);

	if (!itemId) {
		return <Redirect to={Routes.INVENTORY} />;
	}

	if (!!item.loading) {
		return <Spinner />;
	}

	if (!!item.error || !item.data) {
		return <NotFound />;
	}

	return (
		<BaseItemView
			item={item.data}
			skuItems={skuItems.data ?? []}
			inventoryFields={inventoryConfiguration.data?.fields ?? emptyInventoryFields()}
		/>
	);
};

export default SingleItemWrapper;
